// © Microsoft Corporation. All rights reserved.

import { ActivityData, User } from "@msnews/social-data-service";

import ProfileActivityReadMarker from "./ProfileActivityReadMarker";
import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import { SocialState } from "../../Social.state";
import { UsersConnector } from "../../Social.props";
import {activityImages} from "../../utils/images";
import { classNames } from "@microsoft/fast-web-utilities";
import { connect } from "react-redux";
import { enums } from "../../utils/enums";
import getAgoText from "../../utils/getAgoText";
import { hasThemeBase } from "../../utils/themeHelpers";

export interface ProfileBadgeActivityProps {
    activity: ActivityData;
    managedClasses: SocialClassNameContract;
    me: User;
    usersConnector: UsersConnector;
    t: SocialLocalizedStrings;
    theme?: string;
    responsiveClass: string;
}

const mapStateToProps = function(state: SocialState) {
    return {
        theme: state.theme
    };
};

class ProfileBadgeActivity extends React.Component<ProfileBadgeActivityProps> {
    activityItemRef: React.RefObject<HTMLLIElement>;

    private static AchievementMessages;

    constructor(props) {
        super(props);

        this.activityItemRef = React.createRef();
        ProfileBadgeActivity.AchievementMessages = {
            Member: `${props.t.AchievementTitlesMember} ${props.t.AchievementMessagesMember}`,
            Commenter: `${props.t.AchievementTitlesCommenter} ${props.t.AchievementMessagesCommenter}`,
            Networker: `${props.t.AchievementTitlesNetworker} ${props.t.AchievementMessagesNetworker}`,
            ConversationStarter: `${props.t.AchievementTitlesConversationStarter} ${props.t.AchievementMessagesConversationStarter}`
        };
    }

    render() {
        const { responsiveClass, activity, managedClasses, usersConnector, t, theme } = this.props;
        const isSuperApp = hasThemeBase(theme, enums.theme.superappBase);

        if (!activity || !(activity.badgeType in ProfileBadgeActivity.AchievementMessages)) {
            return null;
        }
        const messageText = ProfileBadgeActivity.AchievementMessages[activity.badgeType];

        return (
            <li
                key={activity.id.toString()}
                ref={this.activityItemRef}
                className={classNames(
                    managedClasses.profileActivityContainer,
                    managedClasses.profileActivityBadgeContainer,
                    !activity.isSeen ? "new" : "",
                    [managedClasses.profileActivitySuperAppContainer, isSuperApp],
                    responsiveClass
                )}
            >
                {this.activityItemRef.current && <ProfileActivityReadMarker {...{activity, usersConnector, activityItemRef: this.activityItemRef.current}} />}
                <div className="cwt-start">
                    <img
                        alt={ t.ImgAltsAchievementsLogo }
                        className="cwt-img"
                        src={activityImages.trophy}
                    />
                </div>
                <div className="cwt-mid">
                    <div className="cwt-text">
                        {messageText}
                    </div>
                    <div className="cwt-sub-text">
                        {getAgoText(activity.datetime)}
                    </div>
                </div>
            </li>
        );
    }
}

export default connect(mapStateToProps)(ProfileBadgeActivity);